import { Category } from "scenes/cohort-filters/filter-configs/categories";
import { WidgetType } from "scenes/cohort-filters/filter-configs/widgetTypes";

export const switchWithYearSelectConstructor = ({
    pathToSwitchQuestion,
    pathToYearValue,
    pathToNumberOfEntries,
    category = Category.OTHER,
    label,
}) => ({
    [pathToSwitchQuestion]: {
        widgetType: WidgetType.SWITCH_WITH_YEAR_SELECTOR,
        category: category,
        defaultRuleProperties: {
            value: {
                type: "switchWithYearSelect",
                switchValue: {
                    field: pathToSwitchQuestion,
                    value: true,
                },
                yearValue: {
                    field: pathToYearValue,
                    value: "",
                },
                numberOfEntriesValue: {
                    field: pathToNumberOfEntries,
                    value: "",
                }
            },
            yearOperator: "",
            numberOfEntriesOperator: ""
        },
        widgetConfig: {
            label: label,
            withNumberOfEntries: pathToNumberOfEntries && pathToNumberOfEntries.length > 0
        },
    },
});

